import * as React from "react";
import classnames from "classnames";
import { useConfiguratorContext } from "@grandvisionhq/configurator";
/* empty css                   */
const RxStepWrapper = ({
  children,
  className,
  ...rest
}) => {
  const { isFooterOpen } = useConfiguratorContext();
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      "data-t": rest["data-t"],
      className: classnames("step-wrapper", className, {
        "step-wrapper--summary-expanded": isFooterOpen
      })
    },
    children
  );
};
export {
  RxStepWrapper
};
//# sourceMappingURL=RxStepWrapper.js.map
